import { render, staticRenderFns } from "./Subheader.vue?vue&type=template&id=25b13f3a&scoped=true"
import script from "./Subheader.vue?vue&type=script&lang=js"
export * from "./Subheader.vue?vue&type=script&lang=js"
import style0 from "./Subheader.vue?vue&type=style&index=0&id=25b13f3a&prod&lang=scss"
import style1 from "./Subheader.vue?vue&type=style&index=1&id=25b13f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b13f3a",
  null
  
)

export default component.exports